import type { InjectionKey } from 'vue';
import { inject } from 'vue';

import type { ToastMessagesPlugin } from '../types';

export const PLUGIN_KEY = Symbol('TOAST_MESSAGES_PLUGIN') as InjectionKey<ToastMessagesPlugin>;

export function useToastMessagesPlugin(): ToastMessagesPlugin {
  const plugin = inject<ToastMessagesPlugin>(PLUGIN_KEY);

  if (!plugin) {
    throw new Error('Inject Request was called before initialization. Did you forget to install ToastMessagesPlugin ?');
  }

  return plugin;
}
